const getErrorMessageKeyFromErrorCode = errorCode => {
  switch (errorCode) {
    case 0:
      return 'automationLib.errorMessages.messageNetworkError';
    default:
      return 'automationLib.errorMessages.messageGeneric';
  }
};
export default getErrorMessageKeyFromErrorCode;